import { all, takeEvery, put, call, select } from 'redux-saga/effects'


import { history } from '../../index'
import * as varexeLogin from '../../services/auth'
import actions from './actions'
import store from 'store'
/*
|
*/
import {  message  } from 'antd';
import { request, varexeAPIResponseHandler } from '../../services/api'

const mapAuthProviders = {
  varexeLogin: {
    login: varexeLogin.login,
    loginSocial: varexeLogin.loginSocial,
    forgetpassword: varexeLogin.forgetpassword,
    register: varexeLogin.register,
    logout: varexeLogin.logout,
  },
}

export function* FORGET_PASSWORD({ payload }) {
  const { email } = payload;

  yield put({
  type: 'auth/SET_STATE',
  payload: {
    loading: true,
  },
  });

  try {
    const { authProvider: autProviderName } = yield select(state => state.settings);
    const response = yield call(mapAuthProviders[autProviderName].forgetpassword, email);
    
    yield put({
      type: 'auth/SET_STATE',
      payload: {
        loading: false,
      },
    });

    if (response && response.success === true) {
      if (response.data && response.data.responseStatus === true) {
        yield put({
          type: 'auth/SET_STATE',
          payload: {
            forgetPasswordSuccess: true,
            forgetPasswordEmail: email,
          },
        });
        // Don't redirect immediately, let user see the success message
        varexeAPIResponseHandler.success('Password reset link sent to your email');
      } else {
        yield put({
          type: 'auth/SET_STATE',
          payload: {
            forgetPasswordSuccess: false,
          },
        });
        varexeAPIResponseHandler.error(response.message || 'This email does not exist');
      }
    } else {
      yield put({
        type: 'auth/SET_STATE',
        payload: {
          forgetPasswordSuccess: false,
        },
      });
      varexeAPIResponseHandler.error(response?.message || 'Failed to send password reset link. Please try again.');
    }
  } catch (error) {
    yield put({
      type: 'auth/SET_STATE',
      payload: {
        loading: false,
      },
    });
    // Handle error using varexeAPIResponseHandler
    varexeAPIResponseHandler.handleError(error, { skipAutoHandling: false });
  }
}

export function* LOGIN_SOCIAL({ payload }) {
  const { primaryEmail, accessToken, userID, provider } = payload;             
  
  yield put({
    type: 'auth/SET_STATE',
    payload: {
      loading: true,
    },
  })
  
  try {
    const { authProvider: autProviderName } = yield select(state => state.settings)
    const response = yield call(mapAuthProviders[autProviderName].loginSocial, primaryEmail, accessToken, userID)
    
    if (response) {
      if(response.responseStatus === true) {
        const { token, user } = response;

        // Store token and update API headers
        if (token) {
          store.set('AccessToken', token);
          store.set('auth', response);
          request.updateHeaders(token);
        }

        yield put({
          type: 'auth/SET_STATE',
          payload: {
            user: user,
            authorized: true,
            loading: false,
            provider: provider
          },
        });

        varexeAPIResponseHandler.success('You are logged in');
        
        // Redirect to dashboard
        yield call(history.push, '/dashboard');
      } else {
        varexeAPIResponseHandler.error('We could not find any account associated with your social profile.');
      }
    } else {
      varexeAPIResponseHandler.error('We did not get any response from your social account! Please try again.');
    }
  } catch (error) {
    yield put({
      type: 'auth/SET_STATE',
      payload: {
        loading: false,
      },
    });
    // Handle error using varexeAPIResponseHandler
    varexeAPIResponseHandler.handleError(error, { skipAutoHandling: false });
  }
}

export function* LOGIN({ payload }) {
  const key = 'messageLogin';
  message.open({ key, type: 'loading', content: 'Please wait..' });

  try {
    const { email, password } = payload;
    yield put({ type: 'auth/SET_STATE', payload: { loading: true } });

    const { authProvider: autProviderName } = yield select(state => state.settings);
    const response = yield call(mapAuthProviders[autProviderName].login, email, password);

    if (response && response.success === true) {
      const { user, token, settings } = response.data;

      // Store token and update API headers
      store.set('AccessToken', token);
      store.set('auth', response.data);
      request.updateHeaders(token);

      yield put({
        type: 'auth/SET_STATE',
        payload: {
          auth: response.data,
          authorized: true,
          loading: false,
          page_status: 200,
        },
      });

      message.open({
        key,
        type: 'success',
        content: 'You are logged in!',
      });

      // Redirect to dashboard
      yield call(history.push, '/dashboard');
      
    } else {
      // Close loading message
      message.destroy(key);
      
      // Show error message
      // const errorMessage = response?.message || 'Invalid email or password. Please try again.';
      // varexeAPIResponseHandler.error(errorMessage);
    }
  } catch (error) {
    // Close loading message
    message.destroy(key);
    
    // Check error type - unauthorized, license, and not_found are already shown by interceptor
    // Only show other errors here
    if (error.response) {
      const status = error.response.status;
      if (status === 401 || status === 403 || status === 404) {
        // These errors are already displayed by the interceptor (always shown)
        // Just update state, don't show duplicate error
      } else {
        // Handle other errors using varexeAPIResponseHandler
        varexeAPIResponseHandler.handleError(error, { skipAutoHandling: false });
      }
    } else {
      // Network errors or other non-HTTP errors
      varexeAPIResponseHandler.handleError(error, { skipAutoHandling: false });
    }
    
    yield put({
      type: 'auth/SET_STATE',
      payload: {
        loading: false,
      },
    });
  }
}













export function* REGISTER({ payload }) {
  const { first_name, last_name, primaryEmail, mobile, password  } = payload

  const { authProvider } = yield select(state => state.settings)
  const response = yield call(mapAuthProviders[authProvider].register, first_name, last_name, primaryEmail, mobile, password  )

  if( response )
  {
    if(response.responseStatus === true)
    {

    } else {


      yield put({
        type: 'auth/REGISTER',
        data: response,          
        
      }) 
    }
  }
}


export function* LOGOUT() {
  try {
    const { authProvider } = yield select(state => state.settings);
    const response = yield call(mapAuthProviders[authProvider].logout);

    if (response && response.success === true) {
      store.remove('AccessToken');
      request.updateHeaders(null); // Clear the Authorization header

      varexeAPIResponseHandler.success('Your session has been terminated');
      
      yield history.push('/auth/login');
      yield put({
        type: 'auth/SET_STATE',
        payload: {
          auth: null,
          authorized: false,
          loading: false,
          page_status: 200,
        },
      });
    } else {
      varexeAPIResponseHandler.error(response?.message || 'Failed to logout. Please try again.');
    }
  } catch (error) {
    // Handle error using varexeAPIResponseHandler
    varexeAPIResponseHandler.handleError(error, { skipAutoHandling: false });
    
    // Still clear local state even if logout request failed
    store.remove('AccessToken');
    request.updateHeaders(null);
    yield history.push('/auth/login');
    yield put({
      type: 'auth/SET_STATE',
      payload: {
        auth: null,
        authorized: false,
        loading: false,
        page_status: 200,
      },
    });
  }
}

export default function* rootSaga() {

  // Check for existing session on app start
  const token = store.get('AccessToken');
  const auth = store.get('auth');
  
  if (token && auth) {
    request.updateHeaders(token);
    yield put({
      type: 'auth/SET_STATE',
      payload: {
        auth,
        authorized: true,
        loading: false,
        page_status: 200,
      },
    });
  }

  yield all([
    takeEvery(actions.LOGIN, LOGIN),
    takeEvery(actions.LOGIN_SOCIAL, LOGIN_SOCIAL),
    takeEvery(actions.FORGET_PASSWORD, FORGET_PASSWORD),
    takeEvery(actions.REGISTER, REGISTER),
    takeEvery(actions.LOGOUT, LOGOUT),
  ])
}
